export const initExtra = {
  current: 0,
  native_language: null,
  wholesome_conditions: null,
  elapsed_time: 0,
  isRestarting: null,
  all_items_completed: false,
  last_screen_showed: false,
  finished: false,
  trigger_events: true,
}

export const initAnswers = {
  version: "",
  is_completed: false,
  is_active: true,
  status: "todo",
  locale_id: 0,
  user: {
    uuid: "",
    first_name: "",
    email: "",
    is_recruiter: false,
    is_guest: false,
    gender: "",
  },
  audio: false,
  data: {
    tutorial_time: {
      step_1: 0,
      step_2: 0,
      step_3: 0,
      step_4: 0,
      finished: false,
    },
    trial: {
      step_1: {
        time: 0,
        errors: 0,
      },
      step_2: {
        time: 0,
        errors: 0,
      },
      step_3: {
        time: 0,
        errors: 0,
      },
      retries: 0,
      finished: false,
    },
    items: [],
    extra: initExtra,
  },
  permissions: [],
}

const factoryItem = (id: number) => ({
  item_id: `swipe_v1_item_${String(id).padStart(2, "0")}`,
  time_initial: Math.round(Math.random() * 2000) / 1000,
  answer_initial: null,
  time_x1: 0,
  time_final: 0,
  answer: `swipe_v1_proposal_${String(id).padStart(2, "0")}_${Math.random() < 0.5 ? 1 : 2}`,
  bolt_back: 0,
  device_type: "desktop",
  screen_width: 3840,
  audio: false,
})

export const factoryTest = (locale_id: number, restarting: boolean) => {
  return {
    version: "en_US_1.0.0",
    locale_id: locale_id,
    data: {
      extra: {
        current: 73,
        all_items_completed: false,
        isRestarting: restarting,
        finished: false,
        elapsed_time: 0,
        native_language: null,
        trigger_events: true,
        wholesome_conditions: null,
      },
      items: Array.from({ length: 73 }, (_, i) => factoryItem(i + 1)),
      trial: {
        step_1: {
          time: 1.782,
          errors: 0,
        },
        step_2: {
          time: 0.469,
          errors: 0,
        },
        step_3: {
          time: 0,
          errors: 0,
        },
        retries: 0,
        finished: true,
      },
      tutorial_time: {
        step_1: 1.408,
        step_2: 0.579,
        step_3: 0,
        step_4: 0,
        finished: true,
      },
    },
  }
}
